import { useFriends } from 'hooks/queries/friends';

const useFriendsListModal = (userId: string) => {
  const { data } = useFriends({ id: userId });

  return { data };
};

export default useFriendsListModal;
